export const searchWords = (text) =>
  (text || "").toLowerCase().split(/\s+/).filter(Boolean);

export const productMatchesWords = (product, words) => {
  const text = `${product?.name || ""} ${product?.branch?.name || ""}`.toLowerCase();
  return words.every((word) => text.includes(word));
};

const longestWord = (words) =>
  words.reduce((longest, word) => (word.length > longest.length ? word : longest), "");

// Production /items/details/ rebuilds the list when my_branch is sent, dropping
// search_text. Franchise-level logins are franchise-scoped without it; restaurant
// logins need it to stay on their own restaurant, so they are searched here.
export const productListQuery = ({ searchText, franchiseLevel }) => {
  const words = searchWords(searchText);
  if (words.length === 0) {
    return { params: "my_branch=true&search_text=", words, filterInBrowser: false };
  }
  const search = `search_text=${encodeURIComponent(longestWord(words))}`;
  if (!franchiseLevel) {
    return { params: `my_branch=true&page_wise=false&${search}`, words, filterInBrowser: true };
  }
  const filterInBrowser = words.length > 1;
  return {
    params: filterInBrowser ? `${search}&page_wise=false` : search,
    words,
    filterInBrowser,
  };
};

export const productRows = (responseData) =>
  Array.isArray(responseData) ? responseData : responseData?.results || [];
